import React from 'react';
import SubModal from './SubModal';

/**
 * Props:
 *  - show          {bool}
 *  - onClose       {function}  "Not Now" / backdrop / X
 *  - validity      {string}    e.g. "1 Month"
 *  - amount        {number|string}
 *  - gst           {number|string}
 *  - total         {number|string}
 *  - autoPay       {bool}
 *  - onAutoPayChange {function} (checked) => void
 *  - onConfirmPay  {function}
 */
const ClinicPlanRenewalModal = ({
  show,
  onClose,
  validity = '1 Month',
  amount = 'XXXX',
  gst = 'XXX',
  total = 'XXXX',
  autoPay,
  onAutoPayChange,
  onConfirmPay,
}) => (
  <SubModal show={show} onClose={onClose} contentClassName="sub-modal-content-left">
    <h3 className="sub-modal-title sub-modal-title-left">Clinic Plan Renewal</h3>

    <div className="sub-summary">
      <div className="sub-summary-row">
        <span className="sub-summary-label">Validity</span>
        <span className="sub-summary-value">{validity}</span>
      </div>
      <div className="sub-summary-row">
        <span className="sub-summary-label">Amount</span>
        <span className="sub-summary-value">&#8377; {amount}</span>
      </div>
      <div className="sub-summary-row">
        <span className="sub-summary-label">GST</span>
        <span className="sub-summary-value">&#8377; {gst}</span>
      </div>
      <div className="sub-summary-divider"></div>
      <div className="sub-summary-row sub-summary-total">
        <span className="sub-summary-label">Total</span>
        <span className="sub-summary-value">&#8377; {total}</span>
      </div>
    </div>

    <div className="sub-autopay">
      <span className="sub-autopay-label">Auto Pay</span>
      <label className="switch mb-0">
        <input
          type="checkbox"
          checked={autoPay}
          onChange={(e) => onAutoPayChange?.(e.target.checked)}
        />
        <span className="slider"></span>
      </label>
    </div>
    <p className="sub-autopay-note">
      Your card will be charged automatically each month. Cancel anytime.
    </p>

    <div className="sub-actions">
      <button
        type="button"
        className="btn bg-dg c-w w-100 fw-semibold py-2"
        onClick={() => { onConfirmPay?.(); onClose?.(); }}
      >
        Confirm &amp; Pay
      </button>
      <button type="button" className="sub-btn-ghost w-100" onClick={onClose}>
        Not Now
      </button>
    </div>
  </SubModal>
);

export default ClinicPlanRenewalModal;
